// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__qs6ky","filters_close":"FiltersBlock_filters_close__w7gWp"};